<div class="flex h-full w-full flex-col">
  <dojo-question-validation-header class="!border-t-0">Upload your solution</dojo-question-validation-header>

  <div class="border-b p-4">
    <div class="text-md pb-3">
      Solve the question with pen and paper and upload your solution by taking a picture with your camera
    </div>

    <div class="flex gap-2">
      <dojo-button [customColor]="'indigo'" [style]="{ width: '70px' }" fill="outline" (click)="openUploadDialog()">
        <dojo-icon class="mr-2" [size]="16" [icon]="'camera'" />
        Upload ({{ uploadedImagesCount() }})
      </dojo-button>

      <dojo-icon-button
        [icon]="'refresh'"
        [size]="'s'"
        [pending]="isRefreshing()"
        (click)="refreshSolutionImages()"
        class="text-neutral-600 hover:text-neutral-800 dark:text-neutral-400 dark:hover:text-neutral-200"
        [matTooltip]="'Refresh solution images'"
      />
    </div>
  </div>

  <ng-template #consensusFeedbackTemplate>
    <div class="scrollbar-gutter-stable overflow-y-auto pl-2">
      @if (state.showConsensusWarning) {
        <div class="px-2 py-4 text-center text-orange-400 dark:text-orange-300">
          You are seeing this question again because you did not reach consensus with another reviewer. Please review
          the question carefully again.
        </div>
      }
      <dojo-consensus-feedback-form
        [activeReviewMode]="reviewType()"
        [calculatorAllowed]="calculatorAllowed()"
        [checklistConfig]="dynamicSurveyConfig()"
        [editingAllowed]="editingAllowed()"
        [markschemeInfo]="markschemeInfo()"
        #feedbackComponent
        (formStateChange)="formStateChange.emit($event)"
      />
    </div>
  </ng-template>

  @if (uploadedImagesCount() > 0) {
    @if (showPreviousFeedback().length > 0) {
      <mat-tab-group
        class="custom-mat-tab tabs-body-expanded flex-1"
        style="height: calc(100% - 120px)"
        mat-stretch-tabs="false"
        mat-align-tabs="center"
        animationDuration="250ms"
      >
        <mat-tab class="h-[45px]">
          <ng-template mat-tab-label>
            <span>My Evaluation</span>
          </ng-template>
          <ng-container *ngTemplateOutlet="consensusFeedbackTemplate"></ng-container>
        </mat-tab>

        <mat-tab class="h-[45px]">
          <ng-template mat-tab-label>
            <span>Previous Evaluations ({{ state.previousEvaluations.length }})</span>
          </ng-template>
          <dojo-previous-evaluations
            [evaluations]="state.previousEvaluations"
            [calculatorAllowed]="calculatorAllowed()"
            [markschemeInfo]="markschemeInfo()"
            (formStateChange)="formStateChange.emit($event)"
          >
            <ng-template #badgeTemplate let-evaluation>
              <dojo-question-review-type-badge [reviewType]="evaluation.reviewType" />
            </ng-template>
          </dojo-previous-evaluations>
        </mat-tab>
      </mat-tab-group>
    } @else {
      <dojo-question-validation-header class="border-t">Evaluate the question</dojo-question-validation-header>
      <ng-container *ngTemplateOutlet="consensusFeedbackTemplate"></ng-container>
    }
  }
</div>
